import { render, staticRenderFns } from "./wiki-object-form.vue?vue&type=template&id=16efb86a&"
import script from "./wiki-object-form.vue?vue&type=script&lang=ts&"
export * from "./wiki-object-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports